// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBoundaryFallback_wrapper__WAl4N","grow":"ErrorBoundaryFallback_grow__LinGY"};